import { Injectable } from "@angular/core";

import { UserNotificationListResponse } from "@app/core/notifications/domain/user-notification-list-response";

@Injectable({
  providedIn: "root",
})
export class UserNotificationListResponseMapper {
  static deserialize(dto: any): UserNotificationListResponse {
    return {
      numNotifications: dto.num_notifications,
      numUnreadNotifications: dto.num_unread_notifications,
      notifications: dto.notifications.map((notification: any) => ({
        id: notification.id,
        title: notification.subtitle,
        contents: notification.contents,
        isRead: notification.read,
        url: notification.url,
      })),
    };
  }
}
